import axiosInstance from "auth/FetchInterceptor";
import { VEHICLE_API, CREATE_VEHICLE, UPDATE_VEHICLE, GET_ALL_VEHICLE, VEHICLE_SUMMARY, CHANGE_STATUS_VEHICLE } from "constants/ApiConstant";
const VehicleService = {};

VehicleService.getVehicleSummary = function () {
    return axiosInstance.get(VEHICLE_SUMMARY, null);
};

VehicleService.getListVehicle = function (data) {
    return axiosInstance.post(GET_ALL_VEHICLE, data);
};

VehicleService.getVehicleById = function (id) {
    return axiosInstance.get(`${VEHICLE_API}/${id}`, null);
};

VehicleService.createVehicle = function (data) {
    return axiosInstance.post(CREATE_VEHICLE, data);
};

VehicleService.updateVehicle = function (data) {
    return axiosInstance.put(UPDATE_VEHICLE, data);
};

VehicleService.delVehicle = function (id) {
    return axiosInstance.delete(`${VEHICLE_API}/id?id=${id}`, null);
};

VehicleService.changeStatusVehicleApi = function (data) {
    return axiosInstance.put(CHANGE_STATUS_VEHICLE, data);
};

export default VehicleService;